<template>
  <affix
    class="small-categories light-shadow d-sm-block d-md-none"
    relative-element-selector="#home-section"
    :vertical="true"
    :offset="{ top: 163, bottom: 0, padding: 0 }"
    :style="myTheme.categories.normal"
  >
    <div class="container">
      <div class="row">
        <div class="col-lg-3 col-md-4 d-none d-sm-block"></div>
        <div class="col-md-8 col-lg-5 mx-auto" ref="smallMenuContainer">
          <div class="scrollmenu" :style="{'max-width' : windowWidth}" >
            <a  v-if="selectedLocation.specials && selectedLocation.specials.length"
                @click="onCategoryClick('special')"
                :style="[activeCategory == 'special' ? myTheme.categories.active : '']"
                v-scroll-to="{ el: '#special', offset: -220 }"
                id="special_id"
                data-toggle="list"
                class="btn-round"
                >{{$t('text.special')}}</a>  
              <a  v-for="(category, index) in categories"
                :key="index" 
                @click="onCategoryClick(category.id)"
                :style="[activeCategory == category.id ? myTheme.categories.active : '']"
                v-scroll-to="{ el: '#cat_' + category.id, offset: -220 }"
                :id="category.id"
                data-toggle="list"
                class="btn-round"
                >{{ category.name}}</a>           
          </div>
        </div>
        <div class="col-lg-4 d-none d-lg-block"></div>
      </div>
    </div>
  </affix>
</template>
<script>
import { Button, Affix } from "@/components";
export default {
  name:"small-categories-section",
  components: {
    [Button.name]: Button,
    Affix
  },
  props:{
    categories : Array,
    activeCategory: [String, Number]
  },
  data() {
    return {
      mounted: false,
      windowWidth: 0,
    };
  },
  mounted() {
  this.mounted = true;
    //-- init the width
    this.onResize();
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
    

  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
       this.windowWidth = (window.visualViewport.width - 30)+"px";
    },
    onCategoryClick(idCat){
      this.$emit('setActiveCategory',idCat)
    }
  }
};
</script>
<style scoped>
div.scrollmenu {
  background-color: transparent;
  overflow: auto;
  white-space: nowrap;
}

div.scrollmenu a {
  display: inline-block;
  color: inherit;
  text-align: center;
  padding: 7px 14px;
  text-decoration: none;
  margin-top: 3px;
  margin-bottom: 3px;
}
div.scrollmenu a.btn-round{
  border-radius: 30px!important;
}

/*div.scrollmenu a:hover,
div.scrollmenu a.active {
  background-color: #2c2c2c;
  color: white;
}*/
</style>
